/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie'

import logo from '../assets/images/logo.png'
import home from '../assets/images/nav-bar/dashboard.png'
import customers from '../assets/images/nav-bar/customers.png'
import subscribers from '../assets/images/nav-bar/subscribers.png'
import page from '../assets/images/nav-bar/page.png'
import product from '../assets/images/nav-bar/product.png'
import blog from '../assets/images/nav-bar/blog.png'
import order from '../assets/images/nav-bar/order.png'
import setting from '../assets/images/nav-bar/setting.png'
import team from '../assets/images/nav-bar/teams.png'
import coupon from '../assets/images/nav-bar/coupon.png'
import media from '../assets/images/nav-bar/media.png'
import mobileMenu from '../assets/images/nav-bar/mobileMenu.png'
import appearance from '../assets/images/nav-bar/appearance.png'
import avatarImage from '../assets/images/user-icon.png'
import sideLogout from '../assets/images/icon-logout.svg'
import { adminGet } from "../api/adminUser";

import '../assets/css/header.css'
import { hasPermission } from "../utils/functions";
import { getPlacedOrderCount, getSalePersonPlacedOrderCount } from "../api/ordersApi";

function Header(props) {
    const navigate = useNavigate()
    const [isHovered, setIsHovered] = useState(false);
    const [isProductOpen, setIsProductOpen] = useState(false);
    const [isBlogOpen, setIsBlogOpen] = useState(false);
    const [userImage, setUserImage] = useState('');
    const [totalOrderPlaceCount, setTotalOrderPlaceCount] = useState(0);
    const [isAppearanceOpen, setIsAppearanceOpen] = useState(false);
    const userData = useMemo(() => JSON.parse(Cookies.get('adminUserData') || '{}'), []);


    const sidebarClasses = `sidebar ${isHovered && "hover-menu"} ${`stickyBar ${props?.menuActive && 'fullStickyBar'}`}`;


    useEffect(() => {
        const getPlacedOrderCounts = async () => {
            const placedOrderCountResponse = await getPlacedOrderCount()
            const placedSaleOrderCountResponse = await getSalePersonPlacedOrderCount(userData?.adminUserId)
            if (placedOrderCountResponse?.data) {
                if (userData?.role === "Sale Person") {
                    setTotalOrderPlaceCount(placedSaleOrderCountResponse?.data?.placedCount || 0)
                } else {
                    setTotalOrderPlaceCount(placedOrderCountResponse?.data?.placedCount || 0)
                }
            }
        }
        getPlacedOrderCounts()
    }, [])

    useEffect(() => {
        const getData = async () => {
            if (userData?.mediaId) {
                const response = await adminGet(userData?.adminUserId)
                const placedOrderCountResponse = await getPlacedOrderCount()
                const placedSaleOrderCountResponse = await getSalePersonPlacedOrderCount(userData?.adminUserId)
                if (response?.data) {
                    setUserImage(response?.data?.media?.url)
                    if (userData?.role === "Sale Person") {
                        setTotalOrderPlaceCount(placedSaleOrderCountResponse?.data?.placedCount || 0)
                    } else {
                        setTotalOrderPlaceCount(placedOrderCountResponse?.data?.placedCount || 0)
                    }
                }
            }
        }
        if (userData) {
            getData()
        }
    }, [userData])

    const toggleMenu = () => {
        const body = document.body;
        if (props?.menuActive) {
            body.classList.remove('hide-menu');
        } else {
            body.classList.add('hide-menu');
        }
        props?.setMenuActive(!props?.menuActive);
    };

    const handleMouseEnter = () => {
        if (props?.menuActive) {
            setIsHovered(true);
        }
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleHamburgerClick = () => {
        toggleMenu();
        setIsHovered(false);
    };

    const handleLogout = () => {
        Cookies.remove('adminUserData')
        Cookies.remove('adminToken')
        navigate('/login')
    }

    const resetMenuActive = () => {
        props?.setMenuActive(false);
        document.body.classList.remove('hide-menu');
    };

    const handleMenuItemClick = (e, url) => {
        if (props?.isContentChange === true) {
            e.preventDefault();
            props?.showConfirmationPopup(url);
        } else {
            resetMenuActive();
        }
    };

    return (
        <div className={sidebarClasses} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div className="logo-hamburger-menu mobile-view">
                <Link className='logotype' to={'/'}>
                    <img src={logo} alt="Persone" className='logo-icon' />
                    {/* <span><img src={logoText} alt="Persone" className='logo-text' /></span> */}
                </Link>
                <div className='mobile-menuRight'>
                    <button className='hamburger-menu' onClick={handleHamburgerClick} >
                        <span></span>
                    </button>
                </div>
            </div>
            <nav id="myNav">
                <div className="menuWrapper">
                    <div className="logo-hamburger-menu desktop-view">
                        <Link className="logotype" to={"/"}>
                            <img src={logo} alt="Persone" className='logo-icon' />
                            {/* <span><img src={logoText} alt="Persone" className='logo-text' /></span> */}
                        </Link>
                        <button className="hamburger-menu" onClick={handleHamburgerClick} >
                            <span></span>
                        </button>
                    </div>
                    <div className="menu-wrapperBox">
                        <ul className="menuList">
                            {hasPermission('dashboard') && (
                                <li>
                                    <Link className={(props.activePage === 'dashboard') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/" onClick={(e) => { handleMenuItemClick(e, '/') }}>
                                        <img src={home} className="home-icon" alt="home-icon" />
                                        <span>Dashboard</span>
                                    </Link>
                                </li>
                            )}
                            {hasPermission('blog') && (
                                <li className={`has-submenu pages-sub-menu ${isBlogOpen ? "open" : ""}`}>
                                    <div
                                        className={'menuListItem pages-menuListItem'}
                                        onClick={() => setIsBlogOpen(!isBlogOpen)}
                                    >
                                        <img src={blog} className="home-icon" alt="home-icon" />
                                        <span>Blogs</span>
                                    </div>
                                    <ul className="submenu">
                                        {hasPermission('blog') && (
                                            <li>
                                                <Link to="/blog" className={(props.activePage === 'blog' || props.activePage === 'new-blog' || props.activePage === 'edit-blog') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/blog')}>
                                                    All Blogs
                                                </Link>
                                            </li>
                                        )}
                                        {hasPermission('blogCategory') && (
                                            <li>
                                                <Link to="/blog/category" className={(props.activePage === 'blog/category') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/blog/category')}>
                                                    Categories
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </li>
                            )}
                            {hasPermission('pages') && (
                                <li>
                                    <Link className={(props.activePage === 'all-pages' || props.activePage === 'pages') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/all-pages" onClick={(e) => { handleMenuItemClick(e, '/all-pages') }}>
                                        <img src={page} className="home-icon" alt="headphone-icon" />
                                        <span>Pages</span>
                                    </Link>
                                </li>
                            )}
                            {hasPermission('products') && (
                                <li className={`has-submenu pages-sub-menu ${isProductOpen ? "open" : ""}`}>
                                    <div
                                        className={'menuListItem pages-menuListItem'}
                                        // className={(props.activePage === 'pages') ? 'menuListItem menuItemActive pages-menuListItem' : 'menuListItem pages-menuListItem'}
                                        onClick={() => setIsProductOpen(!isProductOpen)}
                                    >
                                        <img src={product} className="home-icon" alt="home-icon" />
                                        <span>Products</span>
                                        {/* <span className="arrow"></span> */}
                                    </div>

                                    <ul className="submenu">
                                        {hasPermission('products') &&
                                            <li>
                                                <Link to="/products/all" className={((props.activePage === 'products/all') || (props.activePage === 'new-product') || (props.activePage === 'edit-product')) ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/products/all')}>
                                                    All Products
                                                </Link>
                                            </li>
                                        }

                                        {hasPermission('productsCategory') &&
                                            <li>
                                                <Link to="/products/category" className={(props.activePage === 'products/category') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/products/category')}>
                                                    Category
                                                </Link>
                                            </li>
                                        }

                                        {hasPermission('productsBrand') &&
                                            <li>
                                                <Link to="/products/brand" className={(props.activePage === 'products/brand' || props.activePage === 'new-brand') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/products/brand')}>
                                                    Brand
                                                </Link>
                                            </li>
                                        }

                                        {hasPermission('productsReview') &&
                                            <li>
                                                <Link to="/products/review" className={(props.activePage === 'products/review') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/products/review')}>
                                                    Review
                                                </Link>
                                            </li>
                                        }
                                        {hasPermission('productsImport') &&
                                            <li>
                                                <Link to="/products/import" className={(props.activePage === 'products/import') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/products/import')}>
                                                    Import Products
                                                </Link>
                                            </li>
                                        }
                                    </ul>
                                </li>
                            )}
                            {hasPermission('orders') && (
                                <li>
                                    <Link className={(props.activePage === 'all-orders' || props.activePage === 'order-detail') ? 'order-count-item menuListItem menuItemActive' : 'order-count-item menuListItem'} to="/orders" onClick={(e) => { handleMenuItemClick(e, '/orders') }}>
                                        <div className="menuListItem">
                                            <img src={order} className="home-icon" alt="headphone-icon" />
                                            <span>Orders</span>
                                        </div>
                                        {totalOrderPlaceCount > 0 && <span className="totalOrderPlaceCount">{totalOrderPlaceCount > 99 ? '99+' : totalOrderPlaceCount}</span>}
                                    </Link>
                                </li>
                            )}
                            {hasPermission('coupons') && (
                                <li>
                                    <Link className={(props.activePage === 'coupon') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/coupon" onClick={(e) => { handleMenuItemClick(e, '/coupon') }}>
                                        <img src={coupon} className="home-icon" alt="home-icon" />
                                        <span>Coupon</span>
                                    </Link>
                                </li>
                            )}

                            {hasPermission('customers') && (
                                <li>
                                    <Link className={(props.activePage === 'customers' || props.activePage === 'edit-customer') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/customers" onClick={(e) => { handleMenuItemClick(e, '/customers') }}>
                                        <img src={customers} className="home-icon" alt="headphone-icon" />
                                        <span>Customers</span>
                                    </Link>
                                </li>
                            )}
                            {hasPermission('subscribers') && (
                                <li>
                                    <Link className={(props.activePage === 'subscribers' || props.activePage === 'edit-subscriber') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/subscribers" onClick={(e) => { handleMenuItemClick(e, '/subscribers') }}>
                                        <img src={subscribers} className="home-icon" alt="subscribers-icon" />
                                        <span>Subscribers</span>
                                    </Link>
                                </li>
                            )}

                            {hasPermission('media') && (
                                <li>
                                    <Link className={(props.activePage === 'media') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/media" onClick={(e) => { handleMenuItemClick(e, '/media') }}>
                                        <img src={media} className="home-icon" alt="home-icon" />
                                        <span>Media</span>
                                    </Link>
                                </li>
                            )}

                            {hasPermission('appearance') && (

                                <li className={`has-submenu pages-sub-menu ${isAppearanceOpen ? "open" : ""}`}>
                                    <div
                                        className={'menuListItem pages-menuListItem'}
                                        // className={(props.activePage === 'pages') ? 'menuListItem menuItemActive pages-menuListItem' : 'menuListItem pages-menuListItem'}
                                        onClick={() => setIsAppearanceOpen(!isAppearanceOpen)}
                                    >
                                        <img src={appearance} className="home-icon" alt="home-icon" />
                                        <span>Appearance</span>
                                        {/* <span className="arrow"></span> */}
                                    </div>

                                    <ul className="submenu">
                                        {hasPermission('menus') && (
                                            <li >
                                                <Link to="/appearance/menus" className={(props.activePage === 'menus') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/appearance/menus')}>
                                                    Menus
                                                </Link>
                                            </li>
                                        )}
                                        {hasPermission('header') && (
                                            <li >
                                                <Link to="/appearance/header" className={(props.activePage === 'header') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/appearance/footer')}>
                                                    Header
                                                </Link>
                                            </li>
                                        )}
                                        {hasPermission('footer') && (
                                            <li >
                                                <Link to="/appearance/footer" className={(props.activePage === 'footer') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/appearance/footer')}>
                                                    Footer
                                                </Link>
                                            </li>
                                        )}
                                        {hasPermission('banner') && (
                                            <li >
                                                <Link to="/appearance/banner" className={(props.activePage === 'banner') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/appearance/banner')}>
                                                    Banner
                                                </Link>
                                            </li>
                                        )}
                                        {hasPermission('location') && (
                                            <li>
                                                <Link to="/appearance/location" className={(props.activePage === 'location') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/appearance/location')}>
                                                    Location
                                                </Link>
                                            </li>
                                        )}
                                        {hasPermission('popup') && (
                                            <li>
                                                <Link to="/appearance/popup" className={(props.activePage === 'popup') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/appearance/popup')}>
                                                    Popup
                                                </Link>
                                            </li>
                                        )}
                                        {hasPermission('whatsapp') && (
                                            <li >
                                                <Link to="/appearance/whatsapp-chat" className={(props.activePage === 'whatsapp-chat') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/appearance/footer')}>
                                                    Whatsapp chat
                                                </Link>
                                            </li>
                                        )}
                                        {hasPermission('tool') && (
                                            <li >
                                                <Link to="/appearance/tool" className={(props.activePage === 'tool') ? 'menuListItem menuItemActive' : 'menuListItem'} onClick={(e) => handleMenuItemClick(e, '/appearance/tool')}>
                                                    Tool
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </li>
                            )}
                            {hasPermission('mobileMenu') && (
                                <li>
                                    <Link className={(props.activePage === 'mobileMenu') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/mobileMenu" onClick={(e) => { handleMenuItemClick(e, '/mobileMenu') }}>
                                        <img src={mobileMenu} className="home-icon" alt="headphone-icon" />
                                        <span>Mobile Menu</span>
                                    </Link>
                                </li>
                            )}
                            {hasPermission('team') && (
                                <li>
                                    <Link className={(props.activePage === 'team') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/team" onClick={(e) => { handleMenuItemClick(e, '/team') }}>
                                        <img src={team} className="home-icon" alt="headphone-icon" />
                                        <span>Teams</span>
                                    </Link>
                                </li>
                            )}

                            {hasPermission('settings') && (
                                <li>
                                    <Link className={(props.activePage === 'setting') ? 'menuListItem menuItemActive' : 'menuListItem'} to="/setting" onClick={(e) => { handleMenuItemClick(e, '/setting') }}>
                                        <img src={setting} className="home-icon" alt="home-icon" />
                                        <span>Setting</span>
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </div>
                    <div className='user-action'>
                        <div className="menuRight">
                            <div className="userProfile">
                                <div className={`avatarVisible`} >
                                    <div className='sidebar-user'>
                                        <img className='avatar' src={userImage || avatarImage} alt='avatar-image' />
                                    </div>
                                    <div className='sidebar-user-content'>
                                        <p className="sidebar-user-name">{userData.name || 'Admin'}</p>
                                        <p className="sidebar-user-mail">{userData.email || 'admin@example.com'}

                                        </p>
                                    </div>
                                </div>
                                <div className="sidebar-logout desktop-view" onClick={handleLogout}>
                                    <img className='icon-logout' src={sideLogout} alt="icon-logout" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
}
export default Header;
